import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useSettingsStore } from '@/api/store/settings';
import {useRoute, useRouter} from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderConfirmation',
  setup(__props) {

const settingsStore = useSettingsStore();

const route = useRoute();
const router = useRouter();

var order_id = route.params.id;

const viewOrder = () => {
    router.push({ name: 'order-view', params: { id: order_id } });
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "mt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "pa-15 text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                class: "b-round-20 pa-10 mx-auto",
                color: _unref(settingsStore).settings.primaryColor,
                style: {"height":"200px","width":"200px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "100",
                    icon: "fa-shopping-bag",
                    class: "text-white"
                  }),
                  _createVNode(_component_v_sheet, {
                    class: "tick-icon-outer pa-2",
                    color: "green"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "30",
                        icon: "fa-check",
                        class: "text-white ma-auto",
                        color: "white"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["color"]),
              _cache[0] || (_cache[0] = _createElementVNode("p", {
                class: "p-text-lg mt-5",
                style: {"line-height":"30px"}
              }, [
                _createTextVNode("Thank you very much,"),
                _createElementVNode("br"),
                _createTextVNode("your payment is processing.")
              ], -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-5" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "b-round-20 text-white",
                color: _unref(settingsStore).settings.buttonColor,
                width: "80%",
                onClick: viewOrder
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("View Order", -1)
                ]))]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})